// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* time css */
.time-picker {
  background-color: #c4c4c4;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
select.selectHour {
  background: #7bbbf4;
}

.time-selector {
  position: relative;
}

.time-selector select {
  width: 80px;
  height: 70px;
  margin-right: 10px;
  padding: 8px;
  appearance: none;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  border-radius: 6px;
  border: none;
  font-size: 48px;
  font-weight: 600;
  background-color: transparent;
}

.clock-face {
  margin-bottom: 20px;
  position: relative;
}

.clock-face svg {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.ampm-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  border: 2px solid #747bff;
  border-radius: 6px;
}
.ampm-buttons button {
  background-color: transparent;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  flex: 1 1;
}

.ampm-buttons button.active {
  background-color: #747bff;
  color: white;
  border-color: transparent;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.buttons button {
  background-color: #ccc;
  color: #000;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  margin-left: 10px;
  outline: none;
}

/* .buttons button:first-child {
  background-color: #ccc;
  color: black;
} */

.buttons button:hover {
  opacity: 0.8;
}
/* button {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #1a1a1a;
  cursor: pointer;
  transition: border-color 0.25s;
}
button:hover {
  border-color: #646cff;
}
button:focus,
button:focus-visible {
  outline: 4px auto -webkit-focus-ring-color;
} */

@media (prefers-color-scheme: light) {
  :root {
    color: #213547;
    background-color: #ffffff;
  }
  a:hover {
    color: #747bff;
  }
  button {
    background-color: #f9f9f9;
  }
}
button.selected {
  background: #4caf50;
  outline: none;
  color: #fff;
}

.time-show {
  display: flex;
  gap: 20px;
}
.time-show span {
  font-size: 48px;
  font-weight: 600;
}
.hour-picker,
.minute-picker {
  display: flex;
  flex-direction: column;
  height: 140px;
  overflow-y: scroll;
}
.hour-picker button,
.minute-picker button {
  border: none;
}
/* end css */
.modal-backdrop.show {
  opacity: 0;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/component/front/Time.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EAEZ,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,YAAY;AACd;AACA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,YAAY;AACd;AACA,YAAY;AACZ;EACE,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":["/* time css */\n.time-picker {\n  background-color: #c4c4c4;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  font-family: Arial, sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nselect.selectHour {\n  background: #7bbbf4;\n}\n\n.time-selector {\n  position: relative;\n}\n\n.time-selector select {\n  width: 80px;\n  height: 70px;\n  margin-right: 10px;\n  padding: 8px;\n  font-size: 14px;\n  appearance: none;\n  user-select: none;\n  text-align: center;\n  border-radius: 6px;\n  border: none;\n  font-size: 48px;\n  font-weight: 600;\n  background-color: transparent;\n}\n\n.clock-face {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.clock-face svg {\n  width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n}\n\n.ampm-buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n  border: 2px solid #747bff;\n  border-radius: 6px;\n}\n.ampm-buttons button {\n  background-color: transparent;\n  border: none;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  flex: 1;\n}\n\n.ampm-buttons button.active {\n  background-color: #747bff;\n  color: white;\n  border-color: transparent;\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.buttons button {\n  background-color: #ccc;\n  color: #000;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-left: 10px;\n  outline: none;\n}\n\n/* .buttons button:first-child {\n  background-color: #ccc;\n  color: black;\n} */\n\n.buttons button:hover {\n  opacity: 0.8;\n}\n/* button {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 0.6em 1.2em;\n  font-size: 1em;\n  font-weight: 500;\n  font-family: inherit;\n  background-color: #1a1a1a;\n  cursor: pointer;\n  transition: border-color 0.25s;\n}\nbutton:hover {\n  border-color: #646cff;\n}\nbutton:focus,\nbutton:focus-visible {\n  outline: 4px auto -webkit-focus-ring-color;\n} */\n\n@media (prefers-color-scheme: light) {\n  :root {\n    color: #213547;\n    background-color: #ffffff;\n  }\n  a:hover {\n    color: #747bff;\n  }\n  button {\n    background-color: #f9f9f9;\n  }\n}\nbutton.selected {\n  background: #4caf50;\n  outline: none;\n  color: #fff;\n}\n\n.time-show {\n  display: flex;\n  gap: 20px;\n}\n.time-show span {\n  font-size: 48px;\n  font-weight: 600;\n}\n.hour-picker,\n.minute-picker {\n  display: flex;\n  flex-direction: column;\n  height: 140px;\n  overflow-y: scroll;\n}\n.hour-picker button,\n.minute-picker button {\n  border: none;\n}\n/* end css */\n.modal-backdrop.show {\n  opacity: 0;\n  background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
